import type { TNewPresetState } from '../Presets'

export const newPresetInitialStateMaker = (): TNewPresetState => {
  return {
    dayOffsetDateFrom: 14,
    dayOffsetDateTo: 14,
  }
}
